<div style="padding:5px 20px;">
  <h1>{{'change_log'| translation}}</h1>
  <div>
    <div class="change-log-entry" *ngFor="let change of changes">
      <div class="change-log-label">
        <h2>{{change.title}}</h2>
      </div>
      <div class="change-log-details">
        <div *ngFor="let entry of change.items" class="change-log-items">
          <p>{{entry.content}}</p>
        </div>
      </div>
      <hr/>
    </div>
  </div>
  
</div>
